import React, { Component } from 'react';
import { apiCall } from '../utils/api';

class AdminPanel extends Component {
    state = {
        videos: [],
        users: [],
        pages: [],
        newVideo: { page_id: '', name: '', youtube_id: '' },
        newUser: { username: '', password: '', is_admin: false },
        newAuthorization: { user_id: '', page_id: '' },
        message: '',
        activeTab: 'videos', // 'videos', 'users', 'authorizations'
        authorizations: []
    };

    componentDidMount() {
        this.fetchVideos();
        this.fetchUsers();
        this.fetchPages();
        this.fetchAuthorizations();
    }

    fetchVideos = async () => {
        try {
            const { user } = this.props;
            const videos = await apiCall(`admin/videos&user_id=${user.id}&token=${user.token}`);
            this.setState({ videos });
        } catch (error) {
            this.setState({ message: 'Erreur lors du chargement des vidéos' });
        }
    };

    fetchUsers = async () => {
        try {
            const { user } = this.props;
            const users = await apiCall(`admin/users&user_id=${user.id}&token=${user.token}`);
            this.setState({ users });
        } catch (error) {
            this.setState({ message: 'Erreur lors du chargement des utilisateurs' });
        }
    };

    fetchPages = async () => {
        try {
            const { user } = this.props;
            const pages = await apiCall(`pages&user_id=${user.id}&token=${user.token}`);
            this.setState({ pages });
        } catch (error) {
            this.setState({ message: 'Erreur lors du chargement des pages' });
        }
    };

    fetchAuthorizations = async () => {
        try {
            const { user } = this.props;
            const authorizations = await apiCall(`admin/authorizations&user_id=${user.id}&token=${user.token}`);
            this.setState({ authorizations });
        } catch (error) {
            this.setState({ message: 'Erreur lors du chargement des autorisations' });
        }
    };

    handleAddVideo = async (e) => {
        e.preventDefault();
        try {
            const { user } = this.props;
            await apiCall(`admin/videos&user_id=${user.id}&token=${user.token}`, this.state.newVideo, true);
            this.setState({ 
                message: 'Vidéo ajoutée !',
                newVideo: { page_id: '', name: '', youtube_id: '' }
            });
            this.fetchVideos();
        } catch (error) {
            this.setState({ message: 'Erreur lors de l\'ajout de la vidéo' });
        }
    };

    handleAddUser = async (e) => {
        e.preventDefault();
        try {
            const { user } = this.props;
            await apiCall(`admin/users&user_id=${user.id}&token=${user.token}`, this.state.newUser, true);
            this.setState({ 
                message: 'Utilisateur ajouté !',
                newUser: { username: '', password: '', is_admin: false }
            });
            this.fetchUsers();
        } catch (error) {
            this.setState({ message: 'Erreur lors de l\'ajout de l\'utilisateur' });
        }
    };

    handleAddAuthorization = async (e) => {
        e.preventDefault();
        try {
            const { user } = this.props;
            await apiCall(`admin/authorize&user_id=${user.id}&token=${user.token}`, this.state.newAuthorization, true);
            this.setState({ 
                message: 'Autorisation ajoutée !',
                newAuthorization: { user_id: '', page_id: '' }
            });
        } catch (error) {
            this.setState({ message: 'Erreur lors de l\'ajout de l\'autorisation' });
        }
    };

    handleDeleteVideo = async (videoId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer cette vidéo ?')) {
            try {
                const { user } = this.props;
                await apiCall(`admin/videos&user_id=${user.id}&token=${user.token}`, { id: videoId }, true, 'DELETE');
                this.setState({ message: 'Vidéo supprimée !' });
                this.fetchVideos();
            } catch (error) {
                this.setState({ message: 'Erreur lors de la suppression de la vidéo' });
            }
        }
    };

    handleDeleteUser = async (userId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer cet utilisateur ? Toutes ses autorisations seront également supprimées.')) {
            try {
                const { user } = this.props;
                await apiCall(`admin/users&user_id=${user.id}&token=${user.token}`, { id: userId }, true, 'DELETE');
                this.setState({ message: 'Utilisateur supprimé !' });
                this.fetchUsers();
            } catch (error) {
                this.setState({ message: 'Erreur lors de la suppression de l\'utilisateur' });
            }
        }
    };

    handleDeleteAuthorization = async (userId, pageId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer cette autorisation ?')) {
            try {
                const { user } = this.props;
                await apiCall(`admin/authorizations&user_id=${user.id}&token=${user.token}`, 
                    { user_id: userId, page_id: pageId }, 
                    true, 
                    'DELETE'
                );
                this.setState({ message: 'Autorisation supprimée !' });
                this.fetchAuthorizations();
            } catch (error) {
                this.setState({ message: 'Erreur lors de la suppression de l\'autorisation' });
            }
        }
    };

    render() {
        return (
            <div className="card bg-dark text-light p-3">
                <h3>Panneau d'administration</h3>
                
                <ul className="nav nav-tabs mb-3">
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${this.state.activeTab === 'videos' ? 'active' : ''}`}
                            onClick={() => this.setState({ activeTab: 'videos' })}
                        >
                            Vidéos
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${this.state.activeTab === 'users' ? 'active' : ''}`}
                            onClick={() => this.setState({ activeTab: 'users' })}
                        >
                            Utilisateurs
                        </button>
                    </li>
                    <li className="nav-item">
                        <button 
                            className={`nav-link ${this.state.activeTab === 'authorizations' ? 'active' : ''}`}
                            onClick={() => this.setState({ activeTab: 'authorizations' })}
                        >
                            Autorisations
                        </button>
                    </li>
                </ul>

                {this.state.message && (
                    <div className="alert alert-success">{this.state.message}</div>
                )}

                {this.state.activeTab === 'videos' && (
                    <div>
                        <h4>Ajouter une vidéo</h4>
                        <form onSubmit={this.handleAddVideo} className="mb-4">
                            <div className="mb-3">
                                <select 
                                    className="form-control bg-dark text-light"
                                    value={this.state.newVideo.page_id}
                                    onChange={(e) => this.setState({ newVideo: {...this.state.newVideo, page_id: e.target.value} })}
                                    required
                                >
                                    <option value="">Sélectionner une page</option>
                                    {this.state.pages.map(page => (
                                        <option key={page.id} value={page.id}>{page.titre}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <input 
                                    type="text"
                                    className="form-control bg-dark text-light"
                                    placeholder="Nom de la vidéo"
                                    value={this.state.newVideo.name}
                                    onChange={(e) => this.setState({ newVideo: {...this.state.newVideo, name: e.target.value} })}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <input 
                                    type="text"
                                    className="form-control bg-dark text-light"
                                    placeholder="ID YouTube"
                                    value={this.state.newVideo.youtube_id}
                                    onChange={(e) => this.setState({ newVideo: {...this.state.newVideo, youtube_id: e.target.value} })}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary">Ajouter</button>
                        </form>

                        <h4>Vidéos existantes</h4>
                        <div className="list-group">
                            {this.state.videos.map(video => (
                                <div key={video.id} className="list-group-item bg-dark text-light d-flex justify-content-between align-items-center">
                                    <div>
                                        <strong>{video.name}</strong> - ID YouTube: {video.youtube_id}
                                    </div>
                                    <button 
                                        className="btn btn-danger btn-sm"
                                        onClick={() => this.handleDeleteVideo(video.id)}
                                    >
                                        Supprimer
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {this.state.activeTab === 'users' && (
                    <div>
                        <h4>Ajouter un utilisateur</h4>
                        <form onSubmit={this.handleAddUser} className="mb-4">
                            <div className="mb-3">
                                <input 
                                    type="text"
                                    className="form-control bg-dark text-light"
                                    placeholder="Nom d'utilisateur"
                                    value={this.state.newUser.username}
                                    onChange={(e) => this.setState({ newUser: {...this.state.newUser, username: e.target.value} })}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <input 
                                    type="password"
                                    className="form-control bg-dark text-light"
                                    placeholder="Mot de passe"
                                    value={this.state.newUser.password}
                                    onChange={(e) => this.setState({ newUser: {...this.state.newUser, password: e.target.value} })}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <div className="form-check">
                                    <input 
                                        type="checkbox"
                                        className="form-check-input"
                                        id="isAdmin"
                                        checked={this.state.newUser.is_admin}
                                        onChange={(e) => this.setState({ newUser: {...this.state.newUser, is_admin: e.target.checked} })}
                                    />
                                    <label className="form-check-label" htmlFor="isAdmin">
                                        Administrateur
                                    </label>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary">Ajouter</button>
                        </form>

                        <h4 className="mt-4">Utilisateurs existants</h4>
                        <div className="list-group">
                            {this.state.users.map(user => (
                                <div key={user.id} className="list-group-item bg-dark text-light d-flex justify-content-between align-items-center">
                                    <div>
                                        <strong>{user.username}</strong>
                                        {user.is_admin && <span className="badge bg-warning ms-2">Admin</span>}
                                    </div>
                                    <button 
                                        className="btn btn-danger btn-sm"
                                        onClick={() => this.handleDeleteUser(user.id)}
                                    >
                                        Supprimer
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {this.state.activeTab === 'authorizations' && (
                    <div>
                        <h4>Associer une page à un utilisateur</h4>
                        <form onSubmit={this.handleAddAuthorization} className="mb-4">
                            <div className="mb-3">
                                <select 
                                    className="form-control bg-dark text-light"
                                    value={this.state.newAuthorization.user_id}
                                    onChange={(e) => this.setState({ newAuthorization: {...this.state.newAuthorization, user_id: e.target.value} })}
                                    required
                                >
                                    <option value="">Sélectionner un utilisateur</option>
                                    {this.state.users.map(user => (
                                        <option key={user.id} value={user.id}>{user.username}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <select 
                                    className="form-control bg-dark text-light"
                                    value={this.state.newAuthorization.page_id}
                                    onChange={(e) => this.setState({ newAuthorization: {...this.state.newAuthorization, page_id: e.target.value} })}
                                    required
                                >
                                    <option value="">Sélectionner une page</option>
                                    {this.state.pages.map(page => (
                                        <option key={page.id} value={page.id}>{page.titre}</option>
                                    ))}
                                </select>
                            </div>
                            <button type="submit" className="btn btn-primary">Associer</button>
                        </form>

                        <h4 className="mt-4">Autorisations existantes</h4>
                        <div className="list-group">
                            {this.state.authorizations?.map(auth => {
                                const user = this.state.users.find(u => u.id === auth.user_id);
                                const page = this.state.pages.find(p => p.id === auth.page_id);
                                return (
                                    <div key={`${auth.user_id}-${auth.page_id}`} 
                                         className="list-group-item bg-dark text-light d-flex justify-content-between align-items-center">
                                        <div>
                                            <strong>{user?.username}</strong> → {page?.titre}
                                        </div>
                                        <button 
                                            className="btn btn-danger btn-sm"
                                            onClick={() => this.handleDeleteAuthorization(auth.user_id, auth.page_id)}
                                        >
                                            Supprimer
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default AdminPanel; 